import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoriesSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            热门游戏分类
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            多样化的游戏类型，满足不同玩家的需求，找到属于你的游戏世界
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {categories.map((category) => (
            <Link
              key={category.slug}
              to={`/category/${category.slug}`}
              className="group flex flex-col items-center p-5 rounded-lg bg-background-50 hover:bg-primary-50/60 transition-all duration-200 cursor-pointer text-center"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 mb-3 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-200">
                <i className={`${category.icon} text-lg`}></i>
              </div>
              <span className="font-heading text-sm text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {category.name}
              </span>
              <span className="text-xs text-foreground-400 mt-1">{category.count}款游戏</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}